import styled from 'styled-components';
// Material UI
import FormControl from '@mui/material/FormControl';

const FormControlContainer = styled(FormControl)`
    display: block;
`;

export default FormControlContainer;
